import React from 'react'
import { useNavigate } from 'react-router-dom'

const NavLinkContainer = ({to, onClick, type, children}) => {
  const navigate = useNavigate()

  // React Router v6 requires query strings to be passed separately
  let toObj = to
  if (typeof to === 'string' && to.includes('?')) {
    const [pathname, search] = to.split('?')
    toObj = { pathname, search: `?${search}` }
  }

  const handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()

    // Defer navigation to next frame to improve INP
    // This allows the browser to complete the paint before heavy navigation work
    requestAnimationFrame(() => {
      onClick?.()
      navigate(toObj)
    })
  }

  return (
    <div className={`nav-link-container ${type}`} onClick={handleClick}>
      {children}
    </div>
  )
}

export default NavLinkContainer
